import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {track} from "../../services/analytics";

const FooterLandingPage = props => {
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('en');
    const [ loading, setLoading ] = useState(true);

    useEffect(()=> {
        const lang = localStorage.getItem('language');
        setLang(lang);
        setLoading(false);
        i18n.changeLanguage(lang)
    },[]);


    const onLanguageHandle = (event) => {
        let newLang = event.target.value;
        localStorage.setItem('language', newLang);
        setLang(newLang)
        i18n.changeLanguage(newLang)
        const link = window.location.href.split(`/${lang}/`) 
    }

    const renderRadioButtons = () => {
        return (
            <div className="">
                <div className="form-check form-check-inline">
                    <input
                        checked={lang === 'en'}
                        name="language"
                        class="form-check-input"
                        onChange={(e) => onLanguageHandle(e)}
                        value="en"
                        type="radio" />
                    <label class="form-check-label">
                        English
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        name="language"
                        value="id"
                        checked={lang === 'id'}
                        type="radio"
                        className="form-check-input"
                        onChange={(e) => onLanguageHandle ( e )}/>
                    <label className="form-check-label">
                        Bahasa
                    </label>
                </div>
            </div>
        )
    }

    return (

        <footer className="page-footer font-small mdb-color pt-4 bg-lighter ">

            <div className="container text-center text-md-left">

                <div className="row text-center text-md-left mt-3 pb-3">

                    <div className="col-md-4 col-lg-4 col-xl-4 mt-3">
                        <img alt="Biteship Icon Logo" src="/images/landing/biteship-logo-icon.png" className="img-fluid" style={{height:50}}/>
                        <h4 className="mt-2 mb-4 font-weight-bold">Ship Better and Smarter.</h4>
                        <p>E-Commerce logistic solution for small medium-sized enterprises in Southeast Asia
                        </p>
                        {renderRadioButtons ()}
                        <h6 className="mt-4 mb-4 font-weight-bold">Kontak</h6>
                        <p>
                            <i className="fas fa-home mr-3"></i>Block 71, Ariobimo Sentral Tower</p>
                        <p>
                            <i className="fas fa-envelope mr-3"></i> info@biteship.com</p>
                        <p>
                            <i className="fas fa-phone mr-3"></i> + 62 811 131 7800
                        </p>
                    </div>


                    <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                        <h6 class="text-uppercase mb-4 font-weight-bold">Tentang</h6>
                        <p>
                           <a href="https://biteship.com/blog" style={{color:'black'}}>Blog</a>
                        </p>
                        <p>
                           <a href="https://biteship.com/community" style={{color:'black'}}>Community</a>
                        </p>
                        <p>
                           <a href="" style={{color:'black'}}>Careers</a>
                        </p>
                        <p>
                           <a href="/shipping" style={{color:'black'}}>Products</a>
                        </p>
                        <p>
                           <a href="/pricing" style={{color:'black'}}>Pricing</a>
                        </p>
                        <p>
                           <a href="https://dashboard.biteship.com/signup" style={{color:'black'}}>Buat Akun</a>
                        </p>
                    </div>

                    {/*<hr class="w-100 clearfix d-md-none"/>*/}

                    <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                        <h6 class="text-uppercase mb-4 font-weight-bold">layanan</h6>
                        <p>
                           <a href="/shipping" style={{color:'black'}}>Shipping</a>
                        </p>
                        <p>
                           <a href="/plugin" style={{color:'black'}}>Plugins</a>
                        </p>
                        <p>
                           <a href="/fulfillment" style={{color:'black'}}>Fulfillment</a>
                        </p>
                        <p>
                           <a href="/cek-resi" style={{color:'black'}}>Cek Resi</a>
                        </p>
                        <p>
                           <a href="/cek-ongkir" style={{color:'black'}}>Cek Ongkir</a>
                        </p>
                    </div>

                    <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                        <h6 class="text-uppercase mb-4 font-weight-bold">Developer</h6>
                        <p>
                           <a href="/docs/api" style={{color:'black'}}>Documentation</a>
                        </p>
                        <p>
                           <a href="https://s.id/biteship-api-guidelines-web" style={{color:'black'}}>Mulai Integrasi</a>
                        </p>
                    </div>

                    <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                        <h6 class="text-uppercase mb-4 font-weight-bold">Lainnya</h6>
                        <p>
                           <a href="https://help.biteship.com" style={{color:'black'}}>Help Center</a>
                        </p>
                        <p>
                           <a href="https://s.id/biteship-web-home-sales-section" style={{color:'black'}}>Hubungi Kami</a>
                        </p>
                        <p>
                           <a href="/privacy" style={{color:'black'}}>Privacy Policy</a>
                        </p>
                        <p>
                           <a href="/tnc" style={{color:'black'}}>Terms & Conditions</a>
                        </p>
                    </div>

                </div>

                <hr/>

                <div className="row d-flex align-items-center">

                    <div className="col-md-7 col-lg-8">

                        <p className="text-center text-md-left">© 2020 Copyright:
                            <a href="/">
                                <strong> PT. Berbagi Inovasi Teknologi</strong>
                            </a>
                        </p>

                    </div>

                    <div className="col-md-5 col-lg-4 ml-lg-0">

                        <div className="text-center text-md-right">
                            <ul className="list-unstyled list-inline">
                                {/*<li class="list-inline-item">*/}
                                {/*    <a class="btn-floating btn-sm rgba-white-slight mx-1">*/}
                                {/*        <i class="fab fa-facebook-f"></i>*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                                {/*<li class="list-inline-item">*/}
                                {/*    <a class="btn-floating btn-sm rgba-white-slight mx-1">*/}
                                {/*        <i class="fab fa-twitter"></i>*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                                {/*<li class="list-inline-item">*/}
                                {/*    <a class="btn-floating btn-sm rgba-white-slight mx-1">*/}
                                {/*        <i class="fab fa-google-plus-g"></i>*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                                {/*<li class="list-inline-item">*/}
                                {/*    <a class="btn-floating btn-sm rgba-white-slight mx-1">*/}
                                {/*        <i class="fab fa-linkedin-in"></i>*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                            </ul>
                        </div>

                    </div>

                </div>

            </div>

        </footer>
    )
};

export default FooterLandingPage;


